<ng-container *ngIf="tabLayout$ | async as tabLayout">
  <!-- SIGA -->
  <ng-container *ngIf="appId === 'siga'; else default">
    <!-- DEFAULT -->
    <ng-container *ngIf="style == 'default'">
      <div class="tab-layout-container is-siga-app">
        <!-- HORIZONTAL -->
        <div class="d-flex flex-row-auto w-100 align-items-center" *ngIf="!tabLayout.verticalLayout">
          <ng-container>
            <!-- CHEVRON LEFT -->
            <div class="navigation-left-navigation-container" *ngIf="hasOverflow && !atStart">
              <div class="d-flex flex-row align-items-center me-2">
                <button class="btn btn-icon btn-sm" (click)="scrollToLeft(150)">
                  <i class="fas fa-chevron-left chevron-icon"></i>
                </button>
                <div class="vertical-separator"></div>
              </div>
            </div>

            <!-- TABS -->
            <div class="tab-scroll w-100" divOverflow (overflow)="onOverflow($event)" (atEnd)="onScrollEnd($event)"
              (atStart)="onScrollStart($event)" #contentTabLayout>
              <ul class="nav nav-pills nav-pills-custom is-horizontal fs-6 fw-semibold flex-nowrap" role="tablist"
                aria-orientation="horizontal" #tabList>
                <ng-container *ngFor="let item of tabLayout.tabItems; let i = index">
                  <li *ngIf="!item.hideTab" class="nav-item" role="presentation">
                    <a class="pill-link text-muted text-active-dark"
                      [class.active]="tabLayout.selectedMenu === item.id"
                      [attr.aria-selected]="tabLayout.selectedMenu === item.id" [attr.id]="item.label + item.id" role="tab"
                      (click)="onTabClick(item.id)">
                      <span *ngIf="item.icon && showIcons" class="nav-icon" aria-hidden="true">
                        <i class="fa-light fa-fw" [ngClass]="'fa-' + item.icon"></i>
                      </span>

                      <span class="nav-text">{{ item.label }}</span>

                      <span *ngIf="item.badge !== undefined" class="tab-badge">{{ item.badge }}</span>
                    </a>
                  </li>
                </ng-container>
              </ul>
            </div>

            <!-- CHEVRON RIGHT -->
            <div class="navigation-right-navigation-container" *ngIf="hasOverflow && !atEnd">
              <div class="d-flex flex-row align-items-center ms-2">
                <div class="vertical-separator"></div>
                <button class="btn btn-icon btn-sm" (click)="scrollToRight(150)">
                  <i class="fas fa-chevron-right chevron-icon"></i>
                </button>
              </div>
            </div>
          </ng-container>
        </div>

        <!-- VERTICAL -->
        <div class="row d-flex flex-column-auto" *ngIf="tabLayout.verticalLayout">
          <ng-container>
            <!-- CHEVRON TOP -->
            <div class="row" *ngIf="hasOverflow && !atStart">
              <div class="d-flex flex-column align-items-center">
                <button class="btn btn-icon btn-sm" (click)="scrollToTop(150)">
                  <i class="fas fa-chevron-up chevron-icon"></i>
                </button>
                <div class="horizontal-separator"></div>
              </div>
            </div>

            <!-- TABS -->
            <div class="row tab-scroll vertical-tab-scroll" [divOverflow]="'height'" [style.--vertical-height]="height ? height + 'px' : '100%'"
              #contentTabLayout
              (overflow)="onOverflow($event)"
              (atStart)="onScrollStart($event)"
              (atEnd)="onScrollEnd($event)">
              <ul class="nav nav-pills nav-pills-custom is-vertical flex-column fs-6 fw-semibold w-100" role="tablist"
                aria-orientation="vertical" #tabList>
                <ng-container *ngFor="let item of tabLayout.tabItems; let i = index">
                  <li *ngIf="!item.hideTab" class="nav-item mt-4 cursor-pointer w-100" role="presentation">
                    <a class="pill-link text-muted text-active-dark position-relative w-100 d-flex justify-content-between"
                      [class.active]="tabLayout.selectedMenu === item.id"
                      [attr.aria-selected]="tabLayout.selectedMenu === item.id" [attr.id]="item.label + item.id" role="tab"
                      (click)="onTabClick(item.id)">
                      <span class="d-inline-flex align-items-center">
                        <span *ngIf="item.icon && showIcons" class="nav-icon me-2" aria-hidden="true">
                          <i class="fa-light fa-fw" [ngClass]="'fa-' + item.icon"></i>
                        </span>
                        <span class="nav-text">{{ item.label }}</span>
                      </span>

                      <span *ngIf="item.badge !== undefined" class="tab-badge">{{ item.badge }}</span>
                    </a>
                  </li>
                </ng-container>
              </ul>
            </div>

            <!-- CHEVRON BOTTOM -->
            <div class="row" *ngIf="hasOverflow && !atEnd">
              <div class="d-flex flex-column align-items-center mt-2">
                <div class="horizontal-separator"></div>
                <button class="btn btn-icon btn-sm" (click)="scrollToBottom(150)">
                  <i class="fas fa-chevron-down chevron-icon"></i>
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <!-- OLD -->
    <ng-container *ngIf="style == 'old'">
      <div class="tab-layout-container scrollable-hidden-scrollbar" [style.--hover-color]="'var(--kt-success)'">
        <!-- HORIZONTAL -->
        <div class="d-flex flex-row-auto" *ngIf="!tabLayout.verticalLayout">
          <!-- CHEVRON LEFT -->
          <div class="navigation-left-navigation-container mt-1" *ngIf="hasOverflow && !atStart">
            <div class="d-flex flex-row align-items-center me-2">
              <button class="btn btn-icon btn-sm" (click)="scrollToLeft(150)">
                <i class="fas fa-chevron-left chevron-icon"></i>
              </button>
              <div class="vertical-separator"></div>
            </div>
          </div>

          <!-- TABS -->
          <div class="tab-scroll" divOverflow (overflow)="onOverflow($event)" (atEnd)="onScrollEnd($event)"
            (atStart)="onScrollStart($event)" #contentTabLayout>
            <ul class="border-transparent fs-5 fw-bold tab-list" #tabList>
              <ng-container *ngFor="let item of tabLayout.tabItems; let i = index">
                <li *ngIf="!item.hideTab" class="nav-item" style="cursor: pointer">
                  <a class="nav-link text-gray-600 text-active-primary py-3 me-3"
                    [attr.id]="item.label + item.id"
                    [class.active]="tabLayout.selectedMenu == item.id" (click)="onTabClick(item.id)">
                    <span class="px-3">
                      {{ item.label }}
                      <i *ngIf="item.icon && showIcons" class="fa-solid ms-1" style="font-size: medium"
                        [ngClass]="'fa-' + item.icon"></i>
                    </span>
                  </a>
                </li>
              </ng-container>
            </ul>
          </div>

          <!-- CHEVRON RIGHT -->
          <div class="navigation-right-navigation-container mt-1" *ngIf="hasOverflow && !atEnd">
            <div class="d-flex flex-row align-items-center ms-2">
              <div class="vertical-separator"></div>
              <button class="btn btn-icon btn-sm" (click)="scrollToRight(150)">
                <i class="fas fa-chevron-right chevron-icon"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- VERTICAL -->
        <div class="row d-flex flex-column-auto" *ngIf="tabLayout.verticalLayout">
          <!-- CHEVRON TOP -->
          <div class="row" *ngIf="hasOverflow && !atStart">
            <div class="d-flex flex-column align-items-center">
              <button class="btn btn-icon btn-sm" (click)="scrollToTop(150)">
                <i class="fas fa-chevron-up chevron-icon"></i>
              </button>
              <div class="horizontal-separator"></div>
            </div>
          </div>

          <!-- TABS -->
          <div class="row tab-scroll vertical-tab-scroll" [divOverflow]="'height'" [style.--vertical-height]="height ? height + 'px' : '100%'"
            #contentTabLayout
            (overflow)="onOverflow($event)"
            (atStart)="onScrollStart($event)"
            (atEnd)="onScrollEnd($event)">
            <ul class="nav nav-pills nav-pills-custom flex-column border-transparent fs-5 fw-bold">
              <ng-container *ngFor="let item of tabLayout.tabItems; let i = index">
                <li *ngIf="!item.hideTab" style="cursor: pointer" class="nav-item mt-10">
                  <a class="nav-link text-muted text-active-success ms-0 py-0 me-10 ps-9 border-0"
                    [class.active]="tabLayout.selectedMenu == item.id" [attr.id]="item.label + item.id" (click)="onTabClick(item.id)">
                    <span>
                      <i *ngIf="item.icon && showIcons" class="fa-solid me-2 fs-3 fa-fw" style="font-size: medium"
                        [ngClass]="'fa-' + item.icon"></i>
                      {{ item.label }}
                    </span>
                    <span class="bullet-custom position-absolute start-0 top-0 w-3px h-100 bg-success rounded-end"></span>
                  </a>
                </li>
              </ng-container>
            </ul>
          </div>

          <!-- CHEVRON BOTTOM -->
          <div class="row" *ngIf="hasOverflow && !atEnd">
            <div class="d-flex flex-column align-items-center mt-2">
              <div class="horizontal-separator"></div>
              <button class="btn btn-icon btn-sm" (click)="scrollToBottom(150)">
                <i class="fas fa-chevron-down chevron-icon"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- OLD DARK -->
    <ng-container *ngIf="style == 'old-dark'">
      <div class="tab-layout-container scrollable-hidden-scrollbar" [style.--hover-color]="'var(--kt-dark)'">
        <!-- HORIZONTAL -->
        <div class="d-flex flex-row-auto" *ngIf="!tabLayout.verticalLayout">
          <!-- CHEVRON LEFT -->
          <div class="navigation-left-navigation-container mt-1" *ngIf="hasOverflow && !atStart">
            <div class="d-flex flex-row align-items-center me-2">
              <button class="btn btn-icon btn-sm" (click)="scrollToLeft(150)">
                <i class="fas fa-chevron-left chevron-icon"></i>
              </button>
              <div class="vertical-separator"></div>
            </div>
          </div>

          <!-- TABS -->
          <div class="tab-scroll" divOverflow (overflow)="onOverflow($event)" (atEnd)="onScrollEnd($event)"
            (atStart)="onScrollStart($event)" #contentTabLayout>
            <ul *ngIf="!tabLayout.verticalLayout" #tabList class="border-transparent fs-5 fw-bold tab-list">
              <ng-container *ngFor="let item of tabLayout.tabItems; let i = index">
                <li *ngIf="!item.hideTab" class="nav-item" style="cursor: pointer">
                  <a class="nav-link text-gray-600 text-active-primary py-3 me-3"
                    [attr.id]="item.label + item.id"
                    [class.active-dark]="tabLayout.selectedMenu == item.id" (click)="onTabClick(item.id)">
                    <span class="rounded px-3 py-2" [class.bg-white]="tabLayout.selectedMenu == item.id">
                      {{ item.label }}
                      <i *ngIf="item.icon && showIcons" class="fa-solid ms-1" style="font-size: medium"
                        [ngClass]="'fa-' + item.icon"></i>
                    </span>
                  </a>
                </li>
              </ng-container>
            </ul>
          </div>

          <!-- CHEVERON RIGHT -->
          <div class="navigation-right-navigation-container mt-1" *ngIf="hasOverflow && !atEnd">
            <div class="d-flex flex-row align-items-center ms-2">
              <div class="vertical-separator"></div>
              <button class="btn btn-icon btn-sm" (click)="scrollToRight(150)">
                <i class="fas fa-chevron-right chevron-icon"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- VERTICAL -->
        <div class="row d-flex flex-column-auto" *ngIf="tabLayout.verticalLayout">
          <!-- CHEVRON TOP -->
          <div class="row" *ngIf="hasOverflow && !atStart">
            <div class="d-flex flex-column align-items-center">
              <button class="btn btn-icon btn-sm" (click)="scrollToTop(150)">
                <i class="fas fa-chevron-up chevron-icon"></i>
              </button>
              <div class="horizontal-separator"></div>
            </div>
          </div>

          <!-- TABS -->
          <div class="row tab-scroll vertical-tab-scroll" [divOverflow]="'height'" [style.--vertical-height]="height ? height + 'px' : '100%'"
            #contentTabLayout
            (overflow)="onOverflow($event)"
            (atStart)="onScrollStart($event)"
            (atEnd)="onScrollEnd($event)">
            <ul class="nav nav-pills nav-pills-custom flex-column border-transparent fs-5 fw-bold">
              <ng-container *ngFor="let item of tabLayout.tabItems; let i = index">
                <li *ngIf="!item.hideTab" style="cursor: pointer" class="nav-item mt-10">
                  <a class="nav-link text-muted text-active-dark ms-0 py-0 me-10 ps-9 border-0"
                    [attr.id]="item.label + item.id"
                    [class.active]="tabLayout.selectedMenu == item.id"
                    [class.active-dark]="tabLayout.selectedMenu == item.id" (click)="onTabClick(item.id)">
                    <span class="rounded px-3 py-2" [class.bg-white]="tabLayout.selectedMenu == item.id">
                      <i *ngIf="item.icon && showIcons" class="fa-solid me-2 fs-3 fa-fw" style="font-size: medium"
                        [ngClass]="'fa-' + item.icon"></i>
                      {{ item.label }}
                    </span>
                    <span class="bullet-custom position-absolute start-0 top-0 w-3px h-100 bg-dark rounded-end"></span>
                  </a>
                </li>
              </ng-container>
            </ul>
          </div>

          <!-- CHEVRON BOTTOM -->
          <div class="row" *ngIf="hasOverflow && !atEnd">
            <div class="d-flex flex-column align-items-center mt-2">
              <div class="horizontal-separator"></div>
              <button class="btn btn-icon btn-sm" (click)="scrollToBottom(150)">
                <i class="fas fa-chevron-down chevron-icon"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- BUTTONS -->
    <ng-container *ngIf="style == 'buttons'">
      <div class="tab-layout-container scrollable-hidden-scrollbar">
        <!-- HORIZONTAL -->
        <div class="d-flex flex-row-auto" *ngIf="!tabLayout.verticalLayout">
          <!-- CHEVRON LEFT -->
          <div class="navigation-left-navigation-container mt-1" *ngIf="hasOverflow && !atStart">
            <div class="d-flex flex-row align-items-center me-2">
              <button class="btn btn-icon btn-sm" (click)="scrollToLeft(150)">
                <i class="fas fa-chevron-left chevron-icon"></i>
              </button>
              <div class="vertical-separator"></div>
            </div>
          </div>

          <!-- TABS -->
          <div class="tab-scroll" divOverflow (overflow)="onOverflow($event)" (atEnd)="onScrollEnd($event)"
            (atStart)="onScrollStart($event)" #contentTabLayout>
            <ul class="border-transparent tab-list" #tabList>
              <ng-container *ngFor="let item of tabLayout.tabItems; let i = index">
                <li *ngIf="!item.hideTab" class="nav-item" style="cursor: pointer">
                  <a class="nav-link text-gray-600 text-active-primary py-3 me-3"
                    [ngClass]="{
                      'default-button': tabLayout.selectedMenu != item.id,
                      'active-button': tabLayout.selectedMenu == item.id
                    }"
                    [attr.id]="item.label + item.id"
                    (click)="onTabClick(item.id)">
                    <span class="rounded-1 px-2 py-1"
                      [ngClass]="{
                        'bg-white': tabLayout.selectedMenu != item.id,
                        'bg-light-secondary': tabLayout.selectedMenu == item.id
                      }">
                      {{ item.label }}
                      <i *ngIf="item.icon && showIcons" class="fa-solid ms-1" [ngClass]="'fa-' + item.icon"></i>
                    </span>
                  </a>
                </li>
              </ng-container>
            </ul>
          </div>

          <!-- CHEVRON RIGHT -->
          <div class="navigation-right-navigation-container mt-1" *ngIf="hasOverflow && !atEnd">
            <div class="d-flex flex-row align-items-center ms-2">
              <div class="vertical-separator"></div>
              <button class="btn btn-icon btn-sm" (click)="scrollToRight(150)">
                <i class="fas fa-chevron-right chevron-icon"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- VERTICAL -->
        <div class="row d-flex flex-column-auto" *ngIf="tabLayout.verticalLayout">
          <!-- CHEVRON TOP -->
          <div class="row" *ngIf="hasOverflow && !atStart">
            <div class="d-flex flex-column align-items-center">
              <button class="btn btn-icon btn-sm" (click)="scrollToTop(150)">
                <i class="fas fa-chevron-up chevron-icon"></i>
              </button>
              <div class="horizontal-separator"></div>
            </div>
          </div>

          <!-- TABS -->
          <div class="row tab-scroll vertical-tab-scroll" [divOverflow]="'height'" [style.--vertical-height]="height ? height + 'px' : '100%'"
            #contentTabLayout
            (overflow)="onOverflow($event)"
            (atStart)="onScrollStart($event)"
            (atEnd)="onScrollEnd($event)">
            <ul class="nav nav-pills-custom flex-column border-transparent fs-7">
              <ng-container *ngFor="let item of tabLayout.tabItems; let i = index">
                <li *ngIf="!item.hideTab" style="cursor: pointer" class="nav-item">
                  <a class="nav-link text-gray-600 text-active-primary py-3 me-3"
                    [ngClass]="{
                      'default-button': tabLayout.selectedMenu != item.id,
                      'active-button': tabLayout.selectedMenu == item.id
                    }"
                    [attr.id]="item.label + item.id"
                    (click)="onTabClick(item.id)">
                    <span class="rounded px-2 py-1"
                      [ngClass]="{
                        'bg-white': tabLayout.selectedMenu != item.id,
                        'bg-light-secondary': tabLayout.selectedMenu == item.id
                      }">
                      {{ item.label }}
                      <i *ngIf="item.icon && showIcons" class="fa-solid fa-fw"
                        [ngClass]="'fa-' + item.icon"></i>
                    </span>
                  </a>
                </li>
              </ng-container>
            </ul>
          </div>

          <!-- CHEVRON BOTTOM -->
          <div class="row" *ngIf="hasOverflow && !atEnd">
            <div class="d-flex flex-column align-items-center mt-2">
              <div class="horizontal-separator"></div>
              <button class="btn btn-icon btn-sm" (click)="scrollToBottom(150)">
                <i class="fas fa-chevron-down chevron-icon"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <!-- OTHER APPS -->
  <ng-template #default>
    <!-- DEFAULT -->
    <ng-container *ngIf="style == 'default'">
      <div class="tab-layout-container scrollable-hidden-scrollbar" [style.--hover-color]="'var(--kt-success)'">
        <!-- HORIZONTAL -->
        <div class="d-flex flex-row-auto" *ngIf="!tabLayout.verticalLayout">
          <!-- LEFT CHEVRON -->
          <div class="navigation-left-navigation-container mt-2" *ngIf="hasOverflow && !atStart">
            <div class="d-flex flex-row align-items-center me-2">
              <button class="btn btn-icon btn-sm" (click)="scrollToLeft(150)">
                <i class="fas fa-chevron-left chevron-icon"></i>
              </button>
              <div class="vertical-separator"></div>
            </div>
          </div>

          <!-- TABS -->
          <div class="tab-scroll" divOverflow (overflow)="onOverflow($event)" (atEnd)="onScrollEnd($event)"
            (atStart)="onScrollStart($event)" #contentTabLayout>
            <ul class="border-transparent fs-5 fw-bold tab-list" #tabList>
              <ng-container *ngFor="let item of tabLayout.tabItems; let i = index">
                <li *ngIf="!item.hideTab" class="nav-item" style="cursor: pointer">
                  <a class="nav-link text-gray-600 text-active-primary py-5 me-6"
                    [attr.id]="item.label + item.id"
                    [class.active]="tabLayout.selectedMenu == item.id" (click)="onTabClick(item.id)">
                    <span class="px-3">
                      {{ item.label }}
                      <i *ngIf="item.icon && showIcons" class="fa-solid ms-1" style="font-size: medium"
                        [ngClass]="'fa-' + item.icon"></i>
                    </span>
                  </a>
                </li>
              </ng-container>
            </ul>
          </div>

          <!-- RIGHT CHEVRON -->
          <div class="navigation-right-navigation-container mt-2" *ngIf="hasOverflow && !atEnd">
            <div class="d-flex flex-row align-items-center ms-2">
              <div class="vertical-separator"></div>
              <button class="btn btn-icon btn-sm" (click)="scrollToRight(150)">
                <i class="fas fa-chevron-right chevron-icon"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- VERTICAL -->
        <div class="row d-flex flex-column-auto" *ngIf="tabLayout.verticalLayout">
          <ng-container>
            <!-- CHEVRON TOP -->
            <div class="row" *ngIf="hasOverflow && !atStart">
              <div class="d-flex flex-column align-items-center">
                <button class="btn btn-icon btn-sm" (click)="scrollToTop(150)">
                  <i class="fas fa-chevron-up chevron-icon"></i>
                </button>
                <div class="horizontal-separator"></div>
              </div>
            </div>

            <!-- TABS -->
            <div class="row tab-scroll vertical-tab-scroll" [divOverflow]="'height'" [style.--vertical-height]="height ? height + 'px' : '100%'"
              #contentTabLayout
              (overflow)="onOverflow($event)"
              (atStart)="onScrollStart($event)"
              (atEnd)="onScrollEnd($event)">
              <ul class="nav nav-pills nav-pills-custom flex-column border-transparent fs-5 fw-bold">
                <ng-container *ngFor="let item of tabLayout.tabItems; let i = index">
                  <li *ngIf="!item.hideTab" style="cursor: pointer" class="nav-item mt-10">
                    <a class="nav-link text-muted text-active-success ms-0 py-0 me-10 ps-9 border-0"
                      [attr.id]="item.label + item.id"
                      [class.active]="tabLayout.selectedMenu == item.id" (click)="onTabClick(item.id)">
                      <i *ngIf="item.icon && showIcons" class="fa-solid me-2 fs-3 fa-fw" style="font-size: medium"
                        [ngClass]="'fa-' + item.icon"></i>
                      {{ item.label }}
                      <span class="bullet-custom position-absolute start-0 top-0 w-3px h-100 bg-success rounded-end"></span>
                    </a>
                  </li>
                </ng-container>
              </ul>
            </div>

            <!-- CHEVRON BOTTOM -->
            <div class="row" *ngIf="hasOverflow && !atEnd">
              <div class="d-flex flex-column align-items-center mt-2">
                <div class="horizontal-separator"></div>
                <button class="btn btn-icon btn-sm" (click)="scrollToBottom(150)">
                  <i class="fas fa-chevron-down chevron-icon"></i>
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </ng-template>
</ng-container>

<!-- TEST -->
<ng-container *ngIf="false">
  <!-- OLD - ORIGINAL -->
  <ng-container *ngIf="style == 'default'">
    <div class="tab-layout-container scrollable-hidden-scrollbar">
      <div class="content" divOverflow (overflow)="onOverflow($event)" (atEnd)="onScrollEnd($event)"
        (atStart)="onScrollStart($event)" #contentTabLayout>
        <div class="d-flex flex-row-auto">
          <div class="navigation-left-navigation-container mt-2" *ngIf="hasOverflow && !atStart">
            <div class="d-flex flex-row align-items-middle me-2">
              <button class="btn btn-icon btn-sm" (click)="scrollToLeft(150)">
                <i class="fas fa-chevron-left mt-2 chevron-icon"></i>
              </button>
              <div class="vertical-separator"></div>
            </div>
          </div>
          <ng-container *ngIf="tabLayout$ | async as tabLayout">
            <ul *ngIf="!tabLayout.verticalLayout" class="border-transparent fs-5 fw-bold tab-list" #tabList>
              <ng-container *ngFor="let item of tabLayout.tabItems; let i = index">
                <li *ngIf="!item.hideTab" class="nav-item" style="cursor: pointer">
                  <a class="nav-link text-gray-600 text-active-primary py-5 me-6"
                    [attr.id]="item.label + item.id"
                    [class.active]="tabLayout.selectedMenu == item.id" (click)="onTabClick(item.id)">
                    <span class="px-3">
                      {{ item.label }}
                      <i *ngIf="item.icon && showIcons" class="fa-solid ms-1" style="font-size: medium"
                        [ngClass]="'fa-' + item.icon"></i>
                    </span>
                  </a>
                </li>
              </ng-container>
            </ul>
            <!-- vertical tab layout -->
            <ul *ngIf="tabLayout.verticalLayout"
              class="nav nav-pills nav-pills-custom flex-column border-transparent fs-5 fw-bold">
              <ng-container *ngFor="let item of tabLayout.tabItems; let i = index">
                <li *ngIf="!item.hideTab" style="cursor: pointer" class="nav-item mt-10">
                  <a class="nav-link text-muted text-active-primary ms-0 py-0 me-10 ps-9 border-0"
                    [attr.id]="item.label + item.id"
                    [class.active]="tabLayout.selectedMenu == item.id" (click)="onTabClick(item.id)">
                    <i *ngIf="item.icon && showIcons" class="fa-solid me-2 fs-3 fa-fw" style="font-size: medium"
                      [ngClass]="'fa-' + item.icon"></i>
                    {{ item.label }}
                    <span
                      class="bullet-custom position-absolute start-0 top-0 w-3px h-100 bg-primary rounded-end"></span>
                  </a>
                </li>
              </ng-container>
            </ul>
          </ng-container>
          <div class="navigation-right-navigation-container mt-2" *ngIf="hasOverflow && !atEnd">
            <div class="d-flex flex-row align-items-middle ms-2">
              <div class="vertical-separator"></div>
              <button class="btn btn-icon btn-sm" (click)="scrollToRight(150)">
                <i class="fas fa-chevron-right mt-2 chevron-icon"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>